"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeUndefinedAndDuplicates = removeUndefinedAndDuplicates;
const value_checkers_1 = require("../value-checkers");
function removeUndefinedAndDuplicates(list) {
    const listWithoutUndefined = list.filter((item) => (0, value_checkers_1.isNotUndefinedOrNull)(item));
    return [...new Set(listWithoutUndefined)];
}
//# sourceMappingURL=removeUndefinedAndDuplicates.js.map